"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.unlockGenerationFetch = exports.lockGenerationFetch = exports.clearGenerationSettings = exports.moveUpcomingSettingsToCurrent = exports.markRegenerationRequired = exports.updateGenerationSettings = exports.setGenerationMetadata = void 0;
var initialState = {};
function setGenerationMetadata(metadata) {
    return {
        type: setGenerationMetadata.type,
        payload: { metadata: metadata },
    };
}
exports.setGenerationMetadata = setGenerationMetadata;
setGenerationMetadata.type = "generation/setMetadata";
function updateGenerationSettings(upcomingSettings) {
    return {
        type: updateGenerationSettings.type,
        payload: { upcomingSettings: upcomingSettings },
    };
}
exports.updateGenerationSettings = updateGenerationSettings;
updateGenerationSettings.type = "generation/updateSettings";
function markRegenerationRequired(required, immediate) {
    return {
        type: markRegenerationRequired.type,
        payload: { required: required, immediate: immediate },
    };
}
exports.markRegenerationRequired = markRegenerationRequired;
markRegenerationRequired.type = "generation/markRegenerationRequired";
function moveUpcomingSettingsToCurrent() {
    return {
        type: moveUpcomingSettingsToCurrent.type,
    };
}
exports.moveUpcomingSettingsToCurrent = moveUpcomingSettingsToCurrent;
moveUpcomingSettingsToCurrent.type = "generation/moveUpcomingSettingsToCurrent";
function clearGenerationSettings() {
    return {
        type: clearGenerationSettings.type,
    };
}
exports.clearGenerationSettings = clearGenerationSettings;
clearGenerationSettings.type = "generation/clearGenerationSettings";
function lockGenerationFetch() {
    return {
        type: lockGenerationFetch.type,
    };
}
exports.lockGenerationFetch = lockGenerationFetch;
lockGenerationFetch.type = "generation/lockGenerationFetch";
function unlockGenerationFetch() {
    return {
        type: unlockGenerationFetch.type,
    };
}
exports.unlockGenerationFetch = unlockGenerationFetch;
unlockGenerationFetch.type = "generation/unlockGenerationFetch";
function generationReducer(state, action) {
    var _a;
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case moveUpcomingSettingsToCurrent.type:
            if (!state.upcomingSettings)
                return state;
            return __assign(__assign({}, state), { currentSettings: __assign({}, state.upcomingSettings), upcomingSettings: undefined });
        case setGenerationMetadata.type:
            return __assign(__assign({}, state), { metadata: __assign(__assign({}, ((_a = state.metadata) !== null && _a !== void 0 ? _a : {})), action.payload.metadata) });
        case updateGenerationSettings.type:
            return __assign(__assign({}, state), { metadata: __assign(__assign({}, state.metadata), { lastSettingsUpdate: Date.now() }), upcomingSettings: action.payload.upcomingSettings });
        case markRegenerationRequired.type:
            return __assign(__assign({}, state), { metadata: __assign(__assign({}, state.metadata), { regenerationRequired: action.payload.required, nextRegenerationImmediateSwitch: action.payload.immediate }) });
        case lockGenerationFetch.type:
            return __assign(__assign({}, state), { metadata: __assign(__assign({}, state.metadata), { generationFetchLocked: true }) });
        case unlockGenerationFetch.type:
            return __assign(__assign({}, state), { metadata: __assign(__assign({}, state.metadata), { generationFetchLocked: false }) });
        case clearGenerationSettings.type:
            return {};
        default:
            return state;
    }
}
exports.default = generationReducer;
//# sourceMappingURL=generation.js.map